export enum Sort {
  LastModified = 'lastModified',
  OldestFirst = 'oldestFirst',
  AZ = 'az',
  ZA = 'za',
}

export const SORTING_OPTIONS = {
  [Sort.LastModified]: {
    order: 'date',
    direction: 'desc',
  },
  [Sort.OldestFirst]: {
    order: 'date',
    direction: 'asc',
  },
  [Sort.AZ]: {
    order: 'name',
    direction: 'asc',
  },
  [Sort.ZA]: {
    order: 'name',
    direction: 'desc',
  },
};
